import { useCart } from "lib/hooks/useCart";
import styles from "./PromoCodeChip.module.scss";

export default function PromoCodeChip({ code }) {
  const cart = useCart();

  if (!code) {
    return null;
  }

  const { deletePromoCode, refreshCart } = cart;

  const handlePromoCodeDelete = async (event) => {
    event.preventDefault();
    const response = await deletePromoCode({ promoCode: code });
    refreshCart();
  };

  return (
    <div className={`${styles.promoCode}`}>
      <span>{code}</span>
      <button
        className={`${styles.removePromoCodeButton}`}
        onClick={handlePromoCodeDelete}
      >
        <span className={`${styles.removePromoCodeButtonIcon}`}>X</span>
      </button>
    </div>
  );
}
